module.exports = __webpack_public_path__ + "static/media/rectangle_bodytype.18e3d4e8.png";